<mat-dialog-content class="container__error-dialog">
  <div class="container__error-dialog-content-img">
    <img width="48px" height="48px" src="assets/images/icons/error-moda.png" alt="icon error modal ">
  </div>
  <div class="container__error-dialog-content-text">
    <h1 class="h6_500">{{ title | translate }}</h1>
    <p class="s1_500" *ngIf="subtitle">{{ subtitle | translate }}</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="container__error-dialog-actions">
  <common-buttons-filled class="filters-rigth-create-server" [label]="labelButtonSave | translate" [disabled]="false"
    (output)="onEventAccept(false)"></common-buttons-filled>
</mat-dialog-actions>